import React from "react";

export type tReactRef<T> = React.RefCallback<T> | React.MutableRefObject<T> | React.ForwardedRef<T>;

export const mergeRefs = <T extends unknown>(refs: tReactRef<T>[]) => {
  return (node: T): void => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(node);
      } else if (ref !== null) {
        ref.current = node;
      }
    });
  };
};
